<script>
import { clickOutside } from "../../../Helpers/directives";

export default {
  name: "CIPTravelers",

  props: {
    value: {
      type: Object,
      required: null,
      default: null,
    },
  },

  data() {
    return {
      travelers: {
        adult: 1,
        child: 0,
        infant: 0,
      },
      isOpen: false,
      error: "",
    };
  },

  computed: {
    totalPassengerCount() {
      return this.travelers.adult + this.travelers.child + this.travelers.infant;
    },

    isValid() {
      return !this.error;
    },
  },

  methods: {
    handleShowList() {
      if (window.innerWidth < 993) {
        document.documentElement.classList.add("no-scroll");
      }
      this.isOpen = true;
    },

    handleCloseList() {
      if (this.isOpen) {
        this.isOpen = false;
        if (window.innerWidth < 993) {
          document.documentElement.classList.remove("no-scroll");
        }
      }
    },

    updateTraveler(type, increment) {
      const newValue = this.travelers[type] + increment;

      if (this.totalPassengerCount + increment > 9) {
        this.error = "تعداد کل مسافرین نمیتواند بیشتر از 9 نفر باشد";
        return;
      }

      if (type === "adult" && newValue < this.travelers.infant) {
        this.error = "تعداد بزرگسال نمی تواند کمتر از تعداد نوزاد باشد";
        return;
      }

      if (type === "infant" && newValue > this.travelers.adult) {
        this.error = "تعداد نوزاد نمی تواند بیشتر از تعداد بزرگسال باشد";
        return;
      }

      if (newValue >= 0) {
        this.travelers[type] = newValue;
        this.error = "";

        this.handleEmitTravelers();
      }
    },

    validate() {
      this.error = null;

      let message = null;

      switch (true) {
        case this.totalPassengerCount === 0:
          message = "لطفا حداقل یک مسافر انتخاب کنید";
          break;

        case this.totalPassengerCount > 9:
          message = "تعداد کل مسافرین نمیتواند بیشتر از 9 نفر باشد";
          break;

        case this.travelers.adult < this.travelers.infant:
          message = "تعداد نوزاد نمی تواند بیشتر از تعداد بزرگسال باشد";
          break;
      }

      this.error = message;
    },

    handleEmitTravelers() {
      this.$emit("input", this.travelers);
    },
  },

  mounted() {
    this.handleEmitTravelers();
  },

  directives: {
    "click-outside": clickOutside,
  },
};
</script>

<template>
  <div :class="['booking__item w-100 fa-font', isOpen && 'is-open']" v-click-outside="handleCloseList">
    <div :class="['booking__input', error && 'is-invalid']" @click="handleShowList">
      <label class="booking__input-label">مسافران و کلاس</label>

      <span class="booking__input-value">
        <span v-if="travelers.adult">{{ travelers.adult }} بزرگسال</span>

        <span v-if="travelers.child">{{ travelers.child }} کودک</span>

        <span v-if="travelers.infant">{{ travelers.infant }} نوزاد</span>        
      </span>
    </div>

    <label v-if="error" class="booking__item-validation">{{ error }}</label>

    <div class="booking__passengers" v-if="isOpen">
      <div class="booking__item-header hide-in-desktop">
        <span> مسافران و کلاس </span>

        <button class="icon-close" @click="handleCloseList" />
      </div>

      <div class="booking__passengers-inner">
        <div class="booking__room custom-scroll-bar">
          <div class="booking__passengers-select">
            <div class="booking__passengers-select-header">
              <span class="bold"> مسافران </span>
            </div>

            <ul class="booking__passengers-rows">
              <li class="booking__passengers-row">
                <div class="booking__passengers-row-title">
                  <span>بزرگسال</span>

                  <label>(12 سال به بالا)</label>
                </div>

                <div class="booking__counter">
                  <button
                    class="btn btn-counter icon-plus"
                    @click="updateTraveler('adult', 1)"
                    :disabled="totalPassengerCount >= 9"
                  />

                  <span class="bold"> {{ travelers.adult }} </span>

                  <button
                    class="btn btn-counter icon-min"
                    @click="updateTraveler('adult', -1)"
                    :disabled="totalPassengerCount === 1"
                  />
                </div>
              </li>

              <li class="booking__passengers-row">
                <div class="booking__passengers-row-title">
                  <span>کودک</span>

                  <label>(2 تا 12 سال)</label>
                </div>

                <div class="booking__counter">
                  <button
                    class="btn btn-counter icon-plus"
                    @click="updateTraveler('child', 1)"
                    :disabled="totalPassengerCount >= 9"
                  />

                  <span class="bold"> {{ travelers.child }} </span>

                  <button
                    class="btn btn-counter icon-min"
                    @click="updateTraveler('child', -1)"
                    :disabled="totalPassengerCount === 1"
                  />
                </div>
              </li>

              <li class="booking__passengers-row">
                <div class="booking__passengers-row-title">
                  <span>نوزاد</span>

                  <label>(10 روز تا 2 سال)</label>
                </div>

                <div class="booking__counter">
                  <button
                    class="btn btn-counter icon-plus"
                    @click="updateTraveler('infant', 1)"
                    :disabled="totalPassengerCount >= 9"
                  />

                  <span class="bold"> {{ travelers.infant }} </span>

                  <button
                    class="btn btn-counter icon-min"
                    @click="updateTraveler('infant', -1)"
                    :disabled="totalPassengerCount === 1"
                  />
                </div>
              </li>
            </ul>

            <span class="text-red dis-block p--1" v-if="error">
              {{ error }}
            </span>
          </div>          
        </div>

        <div class="booking__passengers-confirm hide-in-desktop">
          <button class="btn btn-teal w-100" @click="handleCloseList">تایید</button>
        </div>
      </div>
    </div>
  </div>
</template>
